module.exports = __webpack_public_path__ + "img/logo.2852c339.svg";